import { render, staticRenderFns } from "./MarketCartTableVariantTotal.vue?vue&type=template&id=b78e4874&"
import script from "./MarketCartTableVariantTotal.vue?vue&type=script&lang=js&"
export * from "./MarketCartTableVariantTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports